var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00024 10L12.0002 3L20.0002 10V20H15.0002V16C15.0002 15.2044 14.6842 14.4413 14.1216 13.8787C13.559 13.3161 12.7959 13 12.0002 13C11.2046 13 10.4415 13.3161 9.87892 13.8787C9.31631 14.4413 9.00024 15.2044 9.00024 16V20H4.00024V10Z",
    stroke: "#808080",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome11);
export default __webpack_public_path__ + "static/media/home-1 1.f6183b722f46222c039c4ffe3d557901.svg";
export { ForwardRef as ReactComponent };